import {
	SUBCATEGORIES_ROUTE_API,
	GET_LIST_SUBCATEGORIES,
	FETCHING_SUBCATEGORIES,
	GET_DETAIL_SUBCATEGORIES,
	UPDATE_SUBCATEGORIES,
	SUBCATEGORIES_ERROR,
	ADD_SUBCATEGORIES,
	NEW_SUBCATEGORIES,
	DELETE_SUBCATEGORIES,
	GET_OPTION_LIST_SUBCATEGORIES,
} from '../constants';

import { logout } from './authAction';

import { apiClient } from '../utils/Api';
import { manipulateErrors, checkAuthorized } from '../utils';

let subcategoryOptionsRequestSeq = 0;
let listRequestSeq = 0;

export const getSubcategoryOptionsByCategory = (categoryId) => {
	if (!categoryId) {
		subcategoryOptionsRequestSeq += 1;
		return {
			type: GET_OPTION_LIST_SUBCATEGORIES,
			payload: { data: [], status_code: 200 }
		};
	}

	const requestSeq = ++subcategoryOptionsRequestSeq;

	return dispatch => (
		dispatch(isFetch({ type: 'fetch_options', status: true })),
		apiClient().get(SUBCATEGORIES_ROUTE_API, {
			params: {
				category_id: categoryId,
				per_page: 100,
				sort_by: 'name',
				sort_order: 'asc'
			}
		})
			.then(res => {
				if (requestSeq !== subcategoryOptionsRequestSeq) {
					return;
				}
				dispatch(onSuccess(res.data, GET_OPTION_LIST_SUBCATEGORIES));
				dispatch(isFetch({ type: 'fetch_options', status: false }));
			})
			.catch(err => {
				if (requestSeq !== subcategoryOptionsRequestSeq) {
					return;
				}
				dispatch(onError(err));
				dispatch(isFetch({ type: 'fetch_options', status: false }));
			})
	);
};

export const getSubcategoriesList = (query) => {
	const requestSeq = ++listRequestSeq;

	return dispatch => (
		dispatch(isFetch({ type: 'fetch', status: true })),
		apiClient().get(SUBCATEGORIES_ROUTE_API, query)
			.then(res => {
				if (requestSeq !== listRequestSeq) {
					return;
				}
				dispatch(onSuccess(res.data, GET_LIST_SUBCATEGORIES));
				dispatch(isFetch({ type: 'fetch', status: false }));
			})
			.catch(err => {
				if (requestSeq !== listRequestSeq) {
					return;
				}
				dispatch(onError(err));
				dispatch(isFetch({ type: 'fetch', status: false }));
			})
	);
};

export const getDetailSubcategories = (id) => {
	return dispatch => (
		dispatch(isFetch({ type: 'fetch', status: true })),
		apiClient().get(`${SUBCATEGORIES_ROUTE_API}/${id}`)
			.then(res => {
				dispatch(onSuccess(res.data, GET_DETAIL_SUBCATEGORIES));
				dispatch(isFetch({ type: 'fetch', status: false }));
			})
			.catch(err => {
				dispatch(onError(err));
				dispatch(isFetch({ type: 'fetch', status: false }));
			})
	);
};

export const saveSubcategories = (payload) => {
	const { id, category_id, name, active } = payload;
	return dispatch => {
		if (payload.id === undefined) {
			dispatch(createSubcategories({ category_id, name, active }));
		} else {
			dispatch(updateSubcategories(id, { category_id, name, active }));
		}
	};
};

export const createSubcategories = (payload) => {
	return dispatch => (
		dispatch(isFetch({ type: 'submit', status: true })),
		apiClient().post(`${SUBCATEGORIES_ROUTE_API}`, payload)
			.then(res => {
				dispatch(onSuccess(res.data, ADD_SUBCATEGORIES));
				dispatch(isFetch({ type: 'submit', status: false }));
			})
			.catch(err => {
				dispatch(onError(err));
				dispatch(isFetch({ type: 'submit', status: false }));
			})
	);
};

export const updateSubcategories = (id, payload) => {
	return dispatch => (
		dispatch(isFetch({ type: 'submit', status: true })),
		apiClient().patch(`${SUBCATEGORIES_ROUTE_API}/${id}`, payload)
			.then(res => {
				dispatch(onSuccess(res.data, UPDATE_SUBCATEGORIES));
				dispatch(isFetch({ type: 'submit', status: false }));
			})
			.catch(err => {
				dispatch(onError(err));
				dispatch(isFetch({ type: 'submit', status: false }));
			})
	);
};

export const deleteSubcategories = (id) => {
	return dispatch => (
		dispatch(isFetch({ type: 'submit', status: true })),
		apiClient().delete(`${SUBCATEGORIES_ROUTE_API}/${id}`)
			.then(res => {
				const payload = res.status === 204
					? { data: { delete: true }, message: 'Delete has been successfully!', status_code: 204 }
					: res.data;
				dispatch(onSuccess(payload, DELETE_SUBCATEGORIES));
				dispatch(isFetch({ type: 'submit', status: false }));
			})
			.catch(err => {
				dispatch(onError(err));
				dispatch(isFetch({ type: 'submit', status: false }));
			})
	);
};

export const isFetch = (payload) => ({
	type: FETCHING_SUBCATEGORIES,
	payload: payload
});

export const onSuccess = (res, type) => ({
	type: type,
	payload: res
});

export const onError = (err) => {
	if (!checkAuthorized(manipulateErrors(err))) {
		return logout();
	}
	return {
		type: SUBCATEGORIES_ERROR,
		payload: manipulateErrors(err)
	};
};

export const newSubcategories = () => ({
	type: NEW_SUBCATEGORIES
});
